import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-account-report-list',
  templateUrl: './account-report-list.component.html',
  styleUrls: ['./account-report-list.component.css']
})
export class AccountReportListComponent implements OnInit {

  menuList: any;
  allowedComponents = new Set<string>();

  constructor(private router:Router) { }

  ngOnInit(): void {
     this.menuList = JSON.parse(localStorage.getItem('menuList'));
    this.menuList.forEach(menu => {
    menu.menu?.menuComponents?.forEach(component => {
      this.allowedComponents.add(component.name);
    });
  });
  console.log(this.allowedComponents);
  }

  hasAccess(componentName: string): boolean {
  return this.allowedComponents.has(componentName);
}

  monthlyConveyanceDetailsClick(){
    this.router.navigate(['dashboard/monthly-conveyance-detail-report'])
  }
  monthlyConveyanceClick(){
    this.router.navigate(['dashboard/monthly-conveyance-report'])
  }
  employeeSalaryReportClick(){
    this.router.navigate(['dashboard/salary-report'])
  }
  clientConveyanceAssignmentClick(){
    this.router.navigate(['dashboard/client-conveyance-assignment'])
  }
  penaltySummaryClick(){
    this.router.navigate(['dashboard/penalty-summary-report'])
  }
  articleStipendClick(){
    this.router.navigate(['dashboard/stipend-report'])
  }
  bankPaymentReportClick(){
    this.router.navigate(['dashboard/bank-payment'])
  }
  salarySlipClick(){
    this.router.navigate(['dashboard/salary-slip'])
  }
  annualSalaryReportClick(){
    this.router.navigate(['dashboard/annual-salary-report'])
  }
  annualStipendReportClick(){
    this.router.navigate(['dashboard/annual-stipend-report'])
  }
  expenseReimbursementClick(){
    this.router.navigate(['dashboard/expense-reimbursement-report'])
  }
}
